import InFilter from '../../../../common/support/utils/druid/filters/InFilter';
import {
  LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME,
  LAST_ATTRIBUTED_TOUCH_DATA_TILDE_FEATURE,
  LAST_ATTRIBUTED_TOUCH_TYPE,
  LOCAL_CURRENCY,
  SUBTYPE,
} from '../../../../../../shared/constants/cenariusDimensions';
import { DEFAULT_DRUID_FILTERS_LIST } from '../../../../../../shared/constants/defaultDruidDimensions';
import {
  CORE_DATASOURCES,
  COST,
  COST_IN_LOCAL_CURRENCY,
  EO_PAGEVIEW,
} from 'client/js/common/support/eo_mapping/datasources';
import {
  CLICK_TO_EVENT_CALCULATIONS,
  COST_CALCULATIONS_IN_DEFAULT_CURRENCY,
  COST_CALCULATIONS_IN_LOCAL_CURRENCY,
  REVENUE_CALCULATIONS,
} from 'client/js/common/support/eo_mapping';

export const ROI_ANALYTICS_COMPARE_BY_DIMENSIONS = [...DEFAULT_DRUID_FILTERS_LIST, LOCAL_CURRENCY, SUBTYPE];

export const REQUIRED_FILTER = new InFilter(LAST_ATTRIBUTED_TOUCH_DATA_TILDE_FEATURE, ['paid advertising']);

export const DEFAULT_DIMENSIONS = [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME];

export const DEFAULT_FILTER = new InFilter(LAST_ATTRIBUTED_TOUCH_TYPE, ['CLICK']);

export const ROI_ANALYTICS_DATASOURCES_DEFAULT_CURRENCY = Object.keys({ ...CORE_DATASOURCES, [COST]: COST }).filter(
  (e) => e !== EO_PAGEVIEW
);
export const ROI_ANALYTICS_DATASOURCES = [...ROI_ANALYTICS_DATASOURCES_DEFAULT_CURRENCY, COST_IN_LOCAL_CURRENCY];

export const ROI_ANALYTICS_CALCULATIONS_DEFAULT_CURRENCY = [
  ...CLICK_TO_EVENT_CALCULATIONS,
  ...COST_CALCULATIONS_IN_DEFAULT_CURRENCY,
  ...REVENUE_CALCULATIONS,
];
export const ROI_ANALYTICS_CALCULATIONS = [
  ...ROI_ANALYTICS_CALCULATIONS_DEFAULT_CURRENCY,
  ...COST_CALCULATIONS_IN_LOCAL_CURRENCY,
];

export const DEFAULT_ACTIVE_MODE = 'tree';
